import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import aboutImg from '../aboutme.png';
import './About.css';

function About() {
  const [imgRef, imgVisible] = useScrollReveal();
  const [contentRef, contentVisible] = useScrollReveal();

  return (
    <section id="about" className="about">
      <div className="about__container">
        <div
          ref={imgRef}
          className={`about__image-col reveal ${imgVisible ? 'reveal--visible' : ''}`}
        >
          <div className="about__image-wrapper">
            <img src={aboutImg} alt="Hafize Cetin" className="about__photo" />
          </div>
          <div className="about__stats">
            <div className="about__stat">
              <span className="about__stat-number">6+</span>
              <span className="about__stat-label">År som kurator</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-number">1</span>
              <span className="about__stat-label">Publicerad bok</span>
            </div>
          </div>
        </div>

        <div
          ref={contentRef}
          className={`about__content reveal ${contentVisible ? 'reveal--visible' : ''}`}
          style={{ transitionDelay: '0.15s' }}
        >
          <h2 className="section-title">Om Hafize Cetin</h2>
          <p>
            Hafize är beteendevetare med erfarenhet av arbete som skolkurator
            mellan 2017 och 2023 i låg- och mellanstadiet samt i anpassad grundskola.
          </p>
          <p>
            Under dessa år arbetade Hafize med elevhälsa, kartläggningar, sociala
            bedömningar och elevsamtal — både individuellt och i grupp.
          </p>
          <p>
            Som del av elevhälsoteamet (EHT) ledde hon skolans trygghetsteam och
            arbetade med elevfrånvaro i nära samverkan med skolpersonal och skolledning.
          </p>
          <p className="about__book">
            Hafize är också författare till den tvärvetenskapliga boken{' '}
            <em>Slöjan – en kulturhistoria</em>.
          </p>
          <a href="#contact" className="about__cta">
            Ta kontakt
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
